import messages from './translationMessages';
import { formatMessage as t, geti18nLocations, getCurrentLocale } from './language';
import { get } from 'lodash';
import { getConfig } from '../config/portal';

export const getMetaTitle = (page, portal) => {
  return t(get(messages, `${page}.metaElements.title`), { portal });
};

export const urlFromLanguage = (url, language) => {
  const localizedLocation = geti18nLocations(url);
  if (localizedLocation) {
    for (const location of localizedLocation) {
      if (location.lang === language) {
        // For SEO all the canonical URLs should have the secure protocol.
        return location.route.replace('http://', 'https://');
      }
    }
  }
  return `${get(getConfig(), 'host')}${url}`;
};

export const getCanonical = (pathName) => {
  const locale = getCurrentLocale();
  pathName = `${pathName ? (pathName.endsWith('/') ? pathName : `${pathName}/`) : '/'}`;
  return urlFromLanguage(pathName, locale);
};

export const getSeoDataItems = (seoContent, type) => {
  let seoData = [];
  if (seoContent && seoContent.length > 0 && type) {
    seoContent.forEach( seoItem => {
      const listItem = seoItem.categories.find(category => category.includes(type));
      if (listItem) {
        seoData.push({
          title: seoItem.title,
          html: seoItem.html,
          text: seoItem.text,
          id: listItem
        });
      }
    });
  }
  return seoData.sort((a,b) => {
    return a.id > b.id ? 1 : -1;
  });
};
